import * as React from 'react';
import { SVGProps } from 'react';

const IconTestSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 2v3.365l-.982 1.44 4.492-.676-.51-.664V2c.278 0 .5-.224.5-.5S7.778 1 7.5 1h-3a.483.483 0 0 0-.48.5c0 .276.202.5.48.5ZM8.649 7.044l-5.92.89L1.637 9.5c-.388.667.096 1.5.872 1.5h6.982c.776 0 1.26-.833.873-1.5L8.649 7.044Z" />
  </svg>
);
export default IconTestSizeXs;
